import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { defineEnemy, Motion, Pattern } from '../schema';

/** EB-2 — DONJON. Le Mortier qu'on peut DÉMANTELER.
 *
 *  ── Ce qu'il enseigne ──
 *  Le Mortier a appris que la position d'une menace pouvait être une donnée
 *  stable du niveau, un pilier autour duquel PLANIFIER son itinéraire. Le Donjon
 *  pousse la leçon d'un cran : un pilier dont on peut RETIRER des morceaux. Il
 *  s'ancre et ne bouge plus, mais il est hérissé de trois pods, chacun couvrant
 *  un pan de terrain — et faire taire un pod ROUVRE ce pan.
 *
 *  Le joueur ne se demande donc plus seulement « par où je passe », mais « quel
 *  passage vaut la peine d'être OUVERT ». C'est la première fois que le terrain
 *  fixe devient négociable : on ne le subit pas, on le remodèle en choisissant sa
 *  cible. Toutes les autres forteresses se démontent par obligation ou pour
 *  désarmer ; celle-ci se démonte pour se creuser une route.
 *
 *  ── Pourquoi le noyau n'est PAS verrouillé ──
 *  Contrairement au Char, on PEUT ignorer les pods et cracher droit sur le
 *  réacteur (420 PV) : il tombe plus vite que le démontage complet (600 PV de
 *  pods), mais on encaisse alors les trois pods jusqu'au bout. C'est le même
 *  arbitrage que le Bastion — vite et exposé, ou méthodique et sûr — transposé
 *  sur une structure FIXE, où « méthodique » veut dire « j'ouvre d'abord le pod
 *  qui barre là où je veux aller ». Le Donjon propose, il n'impose pas.
 *
 *  ── Pourquoi trois pods aux natures et aux places distinctes ──
 *  Deux éventails qui condamnent le flanc gauche et le flanc droit, un anneau au
 *  sommet pour le volume. Retirer un pod ne soustrait pas « un tiers du feu »
 *  mais une GÉOGRAPHIE précise : l'éventail gauche fait taire la moitié gauche du
 *  danger, pas un tiers diffus. C'est ce qui rend le choix de la cible lisible à
 *  l'œil, sans quoi démonter serait un geste aveugle. */
export default defineEnemy({
  id: 'donjon',
  rank: Rank.Heavy,
  hp: 420,
  visualRadius: 42,
  score: 640,
  telegraph: 1.1,
  drops: 4,
  /* Station à Y = +330, comme le Mortier : au-dessus de la zone de manœuvre,
     assez bas pour que ses pods atteignent le terrain. Descente à 200 u/s puis
     gel définitif — il devient du décor, mais un décor qu'on peut ébrécher. */
  motion: { kind: Motion.Anchor, speed: 200, holdY: 330 },
  emitter: {
    // Le réacteur central : un tir visé clairsemé, juste de quoi punir qui campe
    // pile dessous en croyant y être à l'abri. Le gros du danger est aux pods.
    pattern: Pattern.Aimed,
    every: 2.4,
    count: 2,
    spreadDeg: 12,
    speed: 400,
    firstDelay: 2.2,
    family: Fam.EnemyPink,
  },
  parts: [
    { enemy: 'donjon-pod-g', offX: -62, offY: -12 },
    { enemy: 'donjon-pod-d', offX: 62, offY: -12 },
    { enemy: 'donjon-pod-h', offX: 0, offY: 34 },
  ],
});
